import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Site footer — per brand spec:
 *   - Wordmark alone (no eye icon; eye is already in the header on every page).
 *   - Sized smaller than the header version.
 *   - Centered, paired with a copyright line + Terms link.
 */
export const SiteFooter = ({ className = '' }) => {
  return (
    <footer
      className={`w-full pt-8 pb-10 px-6 flex flex-col items-center gap-3 ${className}`}
      data-testid="site-footer"
    >
      <img
        src="/wordmark-tight.png"
        alt="AUDIVUE"
        className="h-5 w-auto object-contain opacity-90"
        data-testid="footer-wordmark"
      />
      <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.25em] text-zinc-500">
        <span data-testid="footer-copyright">
          © {new Date().getFullYear()} AUDIVUE
        </span>
        <span className="text-zinc-700">·</span>
        <Link
          to="/about"
          className="hover:text-zinc-300 transition-colors"
          data-testid="footer-about-link"
        >
          About
        </Link>
        <span className="text-zinc-700">·</span>
        <Link
          to="/terms"
          className="hover:text-zinc-300 transition-colors"
          data-testid="footer-terms-link"
        >
          Terms
        </Link>
      </div>
    </footer>
  );
};

export default SiteFooter;
